import { _ } from 'lodash';
import { getCurrentInstance, reactive } from 'vue';

export default () => {
  const ctx = getCurrentInstance().proxy;
  const route = ctx.$route;
  return route;
};
